import { render, staticRenderFns } from "./report_param_dna.vue?vue&type=template&id=4e37a5ae&lang=true&"
import script from "./report_param_dna.vue?vue&type=script&lang=js&"
export * from "./report_param_dna.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports